import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import BestParaquatLawyersWrapper from "@components/layouts/bestparaquatlawyersWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <BestParaquatLawyersWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#366e3f" />
                </div>
                <FormSection iconsFillColor="#366e3f" />
            </div>
        </BestParaquatLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
